import { HttpClient, HttpContext, HttpDownloadProgressEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, pairwise } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';

import { skipToastOnErrorContext } from '../context/skip-toast-on-error.context';
import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class NotificationSSEApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  public connect(): Observable<{ notification: NotificationConnectDAO }> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/event-stream',
      'Cache-Control': 'no-cache',
      Connection: 'keep-alive'
    });
    const context = new HttpContext().set(skipToastOnErrorContext, true);

    return this.httpClient
      .get(`${this.baseUrl}/sse/connect`, {
        headers,
        context,
        observe: 'events',
        responseType: 'text',
        reportProgress: true
      })
      .pipe(
        filter((event): event is HttpDownloadProgressEvent => event.type === HttpEventType.DownloadProgress),
        map(event => event.partialText ?? ''),
        startWith(''),
        pairwise(),
        map(([prev, current]) => current.slice(prev.length)),
        map(partialText => {
          const dataStart = 'data: ';
          const dataLine = partialText.split(`\n`).find(e => e.startsWith(dataStart));

          if (!dataLine) {
            return null;
          }
          const data = dataLine.slice(dataStart.length);
          return JSON.parse(data);
        }),
        filter(Boolean)
      );
  }
}
